export const fetchFactureById = async (id_facture) => {

    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    
    const response = await fetch(`${apiUrl}/api/print/facture/${id_facture}`, { 
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to update invoice');
    }

    const data = await response.json();

    console.log("data",data);

    return data;
};